module.exports = __webpack_public_path__ + "img/kyc-nid.85432889.svg";